import { render, staticRenderFns } from "./SubVoce.vue?vue&type=template&id=52d340d9&scoped=true&"
import script from "./SubVoce.vue?vue&type=script&lang=js&"
export * from "./SubVoce.vue?vue&type=script&lang=js&"
import style0 from "./SubVoce.vue?vue&type=style&index=0&id=52d340d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d340d9",
  null
  
)

export default component.exports